import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";

import { fetchRedeemCodes, addRedeemCode, updateRedeemCode, deleteRedeemCode } from "../actions/redeemcodes";
import { fetchMachines } from "../actions/machines";
import { fetchCustomersName, fetchCustomer } from "../actions/customers";

import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";
import FeatureBlockedScreen from "../components/FeatureBlockedScreen";
import "../styles/RedeemCodesView.css";

const LOCKER_TYPES = [
  { code: "BNS", name: "Standard" },
  { code: "CNS", name: "Standard Carga" },
  { code: "BWS", name: "Standard XL" },
  { code: "CWS", name: "Standard Carga XL" },
  { code: "BNM", name: "Medium" },
  { code: "CNM", name: "Medium Carga" },
  { code: "BWM", name: "Medium XL" },
  { code: "CWM", name: "Medium Carga XL" },
  { code: "BNL", name: "Large" },
  { code: "CNL", name: "Large Carga" },
  { code: "BWL", name: "Large XL" },
  { code: "CWL", name: "Large Carga XL" },
  { code: "BNXL", name: "Large 4" },
  { code: "CNXL", name: "Large 4 Carga" },
  { code: "BWXL", name: "Large 4 XL" },
  { code: "CWXL", name: "Large 4 Carga XL" },
  { code: "BN2XL", name: "Large 5" },
  { code: "CN2XL", name: "Large 5 Carga" },
  { code: "BW2XL", name: "Large 5 XL" },
  { code: "CW2XL", name: "Large 5 Carga XL" },
  { code: "BN3XL", name: "Ski" },
  { code: "CN3XL", name: "Ski Carga" },
  { code: "BW3XL", name: "Ski XL" },
  { code: "CW3XL", name: "Ski Carga XL" },
  { code: "XNS", name: "Standard Cupón" },
  { code: "XWS", name: "Standard XL Cupón" },
  { code: "XNM", name: "Medium Cupón" },
  { code: "XWM", name: "Medium XL Cupón" },
  { code: "XNL", name: "Large Cupón" },
  { code: "XWL", name: "Large XL Cupón" },
  { code: "XNXL", name: "Large 4 Cupón" },
  { code: "XWXL", name: "Large 4 XL Cupón" },
  { code: "XN2XL", name: "Large 5 Cupón" },
  { code: "XW2XL", name: "Large 5 XL Cupón" },
  { code: "XN3XL", name: "Ski Cupón" },
  { code: "XW3XL", name: "Ski XL Cupón" },
];

class RedeemCodesView extends React.Component {
  // Helper function to convert date to local datetime-local format
  dateToLocalDatetimeString(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      loaded: false,
      showRedeemedModal: false,
      selectedRedeemedCode: null,
      filterCode: "",
      newRedeemCode: {
        customer: "",
        machine: "",
        origin: "internal",
        products: [],
        valid_from: "",
        valid_to: "",
        code: "",
      },
      currentProductId: "",
      currentProductQty: 1,
      editingProductIndex: null,
      showEditModal: false,
      editRedeemCode: null,
      editProductId: "",
      editProductQty: 1,
      editingEditProductIndex: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
    this.showQRCode = this.showQRCode.bind(this);
    this.closeQRModal = this.closeQRModal.bind(this);
    this.showRedeemedModal = this.showRedeemedModal.bind(this);
    this.closeRedeemedModal = this.closeRedeemedModal.bind(this);
    this.handleProductChange = this.handleProductChange.bind(this);
    this.addProduct = this.addProduct.bind(this);
    this.removeProduct = this.removeProduct.bind(this);
    this.editProduct = this.editProduct.bind(this);
    this.updateProduct = this.updateProduct.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.handleEditInputChange = this.handleEditInputChange.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleDeleteRedeemCode = this.handleDeleteRedeemCode.bind(this);
    this.handleEditProductChange = this.handleEditProductChange.bind(this);
    this.addEditProduct = this.addEditProduct.bind(this);
    this.removeEditProduct = this.removeEditProduct.bind(this);
    this.editEditProduct = this.editEditProduct.bind(this);
    this.updateEditProduct = this.updateEditProduct.bind(this);
  }

  componentDidMount() {
    const { type, role, customerId, fetchMachines, fetchCustomersName } = this.props;
    this.props.fetchRedeemCodes(role !== 'ADMIN' ? customerId : undefined);

    if (role === 'CUSTOMER' && customerId) {
      this.props.fetchCustomer(customerId);
    }

    fetchMachines();

    if (role === "ADMIN" || (role === "CUSTOMER" && type === "GROUP")) {
      fetchCustomersName();
    }

    this.load(this.props);
  }

  componentDidUpdate(prevProps) {
    this.load(this.props);

    if (
      this.props.redeemCodesNeedRefresh &&
      !prevProps.redeemCodesNeedRefresh
    ) {
      const { role, customerId } = this.props;
      this.props.fetchRedeemCodes(role !== 'ADMIN' ? customerId : undefined);
    }
  }

  load(props) {
    const { role, machines, customers } = props;

    if (!this.state.loaded && machines && (role !== "ADMIN" || customers)) {
      this.setState({ loaded: true });
    }
  }

  toggleForm() {
    const { role, customerId } = this.props;
    const isOpening = !this.state.showForm;

    if (isOpening) {
      const now = new Date();
      const pad = n => String(n).padStart(2, '0');
      const toLocalDT = d => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
      const defaultFrom = toLocalDT(now);
      const oneMonthLater = new Date(now); oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
      const defaultTo = toLocalDT(oneMonthLater);

      if (role === "ADMIN") {
        this.setState({
          showForm: true,
          newRedeemCode: {
            ...this.state.newRedeemCode,
            customer: "620d1664db950220fabc0a41",
            valid_from: defaultFrom,
            valid_to: defaultTo,
          },
        });
      } else {
        this.setState({
          showForm: true,
          newRedeemCode: {
            ...this.state.newRedeemCode,
            customer: customerId,
            valid_from: defaultFrom,
            valid_to: defaultTo,
          },
        });
      }
    } else {
      this.setState({ showForm: !this.state.showForm });
    }
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      newRedeemCode: {
        ...this.state.newRedeemCode,
        [name]: value,
      },
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    
    // Sanitize the data before sending
    const sanitizedRedeemCode = {
      ...this.state.newRedeemCode,
      // Machine is always null for new codes
      machine: null,
    };
    
    this.props.addRedeemCode(sanitizedRedeemCode);
    this.setState({
      showForm: false,
      newRedeemCode: {
        customer: "",
        machine: "",
        origin: "internal",
        products: [],
        valid_from: "",
        valid_to: "",
        code: "",
      },
      currentProductId: "",
      currentProductQty: 1,
    });
  }

  showQRCode(redeemCode) {
    this.setState({
      showQRModal: true,
      selectedRedeemCode: redeemCode,
    });
  }

  closeQRModal() {
    this.setState({
      showQRModal: false,
      selectedRedeemCode: null,
    });
  }

  showRedeemedModal(redeemCode) {
    this.setState({
      showRedeemedModal: true,
      selectedRedeemedCode: redeemCode,
    });
  }

  closeRedeemedModal() {
    this.setState({
      showRedeemedModal: false,
      selectedRedeemedCode: null,
    });
  }

  getTypeName(type) {
    switch (type) {
      case "BNS":
        return "Standard";
      case "CNS":
        return "Standard Carga";
      case "BWS":
        return "Standard XL";
      case "CWS":
        return "Standard Carga XL";
      case "BNM":
        return "Medium";
      case "CNM":
        return "Medium Carga";
      case "BWM":
        return "Medium XL";
      case "CWM":
        return "Medium Carga XL";
      case "BNL":
        return "Large";
      case "CNL":
        return "Large Carga";
      case "BWL":
        return "Large XL";
      case "CWL":
        return "Large Carga XL";
      case "BNXL":
        return "Large 4";
      case "CNXL":
        return "Large 4 Carga";
      case "BWXL":
        return "Large 4 XL";
      case "CWXL":
        return "Large 4 Carga XL";
      case "BN2XL":
        return "Large 5";
      case "CN2XL":
        return "Large 5 Carga";
      case "BW2XL":
        return "Large 5 XL";
      case "CW2XL":
        return "Large 5 Carga XL";
      case "BN3XL":
        return "Ski";
      case "CN3XL":
        return "Ski Carga";
      case "BW3XL":
        return "Ski XL";
      case "CW3XL":
        return "Ski Carga XL";
      // Voucher/Coupon Types (X and W, no LOCKER prefix)
      case "XNS":
        return "Standard Cupón";
      case "XWS":
        return "Standard XL Cupón";
      case "XNM":
        return "Medium Cupón";
      case "XWM":
        return "Medium XL Cupón";
      case "XNL":
        return "Large Cupón";
      case "XWL":
        return "Large XL Cupón";
      case "XNXL":
        return "Large 4 Cupón";
      case "XWXL":
        return "Large 4 XL Cupón";
      case "XN2XL":
        return "Large 5 Cupón";
      case "XW2XL":
        return "Large 5 XL Cupón";
      case "XN3XL":
        return "Ski Cupón";
      case "XW3XL":
        return "Ski XL Cupón";
      default:
        return "NONE";
    }
  }

  handleProductChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  addProduct() {
    const { currentProductId, currentProductQty, newRedeemCode } = this.state;
    if (!currentProductId || !currentProductQty) return;

    const locker = LOCKER_TYPES.find((l) => l.code === currentProductId);
    if (!locker) return;

    const product = {
      product_id: null, // Product ID should be null for locker types
      product_name: currentProductId, // Use locker code (BNS, CNS, etc.) as product_name
      product_qty: parseInt(currentProductQty),
      product_price: 0, // No price for now
    };

    this.setState({
      newRedeemCode: {
        ...newRedeemCode,
        products: [...newRedeemCode.products, product],
      },
      currentProductId: "",
      currentProductQty: 1,
    });
  }

  removeProduct(index) {
    const { newRedeemCode } = this.state;
    const products = [...newRedeemCode.products];
    products.splice(index, 1);
    this.setState({
      newRedeemCode: {
        ...newRedeemCode,
        products,
      },
      editingProductIndex: null,
    });
  }

  editProduct(index) {
    this.setState({ editingProductIndex: index });
  }

  updateProduct(index, productId, productQty) {
    const { newRedeemCode } = this.state;
    const locker = LOCKER_TYPES.find((l) => l.code === productId);
    if (!locker) return;

    const products = [...newRedeemCode.products];
    products[index] = {
      product_id: null, // Product ID should be null for locker types
      product_name: productId, // Use locker code (BNS, CNS, etc.) as product_name
      product_qty: parseInt(productQty),
      product_price: 0,
    };

    this.setState({
      newRedeemCode: {
        ...newRedeemCode,
        products,
      },
      editingProductIndex: null,
    });
  }

  openEditModal(redeemCode) {
    this.setState({
      showEditModal: true,
      editRedeemCode: {
        _id: redeemCode._id,
        customer: redeemCode.customer,
        machine: redeemCode.machine,
        origin: redeemCode.origin || "internal",
        products: [...redeemCode.products],
        valid_from: this.dateToLocalDatetimeString(redeemCode.valid_from),
        valid_to: this.dateToLocalDatetimeString(redeemCode.valid_to),
        code: redeemCode.code,
      },
      editProductId: "",
      editProductQty: 1,
      editingEditProductIndex: null,
    });
  }

  closeEditModal() {
    this.setState({
      showEditModal: false,
      editRedeemCode: null,
      editProductId: "",
      editProductQty: 1,
      editingEditProductIndex: null,
    });
  }

  handleEditInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      editRedeemCode: {
        ...this.state.editRedeemCode,
        [name]: value,
      },
    });
  }

  handleEditSubmit(event) {
    event.preventDefault();
    const { editRedeemCode } = this.state;
    const { _id, ...updates } = editRedeemCode;
    
    // Sanitize the data before sending
    const sanitizedUpdates = {
      ...updates,
      // Machine is always null
      machine: null,
    };
    
    this.props.updateRedeemCode(_id, sanitizedUpdates);
    this.closeEditModal();
  }

  handleDeleteRedeemCode(redeemCodeId) {
    if (window.confirm("¿Está seguro de que desea eliminar este código de canje?")) {
      this.props.deleteRedeemCode(redeemCodeId);
    }
  }

  handleEditProductChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  addEditProduct() {
    const { editProductId, editProductQty, editRedeemCode } = this.state;
    if (!editProductId || !editProductQty) return;

    const locker = LOCKER_TYPES.find((l) => l.code === editProductId);
    if (!locker) return;

    const product = {
      product_id: null, // Product ID should be null for locker types
      product_name: editProductId, // Use locker code (BNS, CNS, etc.) as product_name
      product_qty: parseInt(editProductQty),
      product_price: 0,
    };

    this.setState({
      editRedeemCode: {
        ...editRedeemCode,
        products: [...editRedeemCode.products, product],
      },
      editProductId: "",
      editProductQty: 1,
    });
  }

  removeEditProduct(index) {
    const { editRedeemCode } = this.state;
    const products = [...editRedeemCode.products];
    products.splice(index, 1);
    this.setState({
      editRedeemCode: {
        ...editRedeemCode,
        products,
      },
      editingEditProductIndex: null,
    });
  }

  editEditProduct(index) {
    this.setState({ editingEditProductIndex: index });
  }

  updateEditProduct(index, productId, productQty) {
    const { editRedeemCode } = this.state;
    const locker = LOCKER_TYPES.find((l) => l.code === productId);
    if (!locker) return;

    const products = [...editRedeemCode.products];
    products[index] = {
      product_id: null, // Product ID should be null for locker types
      product_name: productId, // Use locker code (BNS, CNS, etc.) as product_name
      product_qty: parseInt(productQty),
      product_price: 0,
    };

    this.setState({
      editRedeemCode: {
        ...editRedeemCode,
        products,
      },
      editingEditProductIndex: null,
    });
  }

  getCustomerName(customerId) {
    const { role, customers, customerFullname } = this.props;
    if (role !== 'ADMIN') return customerFullname || 'Unknown';
    if (!customers || !customerId) return "Unknown";
    const customer = customers.find((c) => c._id === customerId);
    return customer ? customer.Fullname : "Unknown";
  }

  render() {
    const { role, redeemCodes, loading, error, machines, customers, type, customer } =
      this.props;

    if (role === 'CUSTOMER' && customer && customer.FeatureRedeemCodes === false) {
      return <FeatureBlockedScreen featureName="FeatureRedeemCodes" featureLabel="Códigos Canjeables" />;
    }
    const {
      showForm,
      newRedeemCode,
      loaded,
      showQRModal,
      selectedRedeemCode,
      filterCode,
      showRedeemedModal,
      selectedRedeemedCode,
    } = this.state;

    const filteredRedeemCodes = redeemCodes
      ? redeemCodes.filter((rc) =>
          rc.code.toLowerCase().includes(filterCode.toLowerCase())
        )
      : [];

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!redeemCodes || loading) {
      return <LoadingProgress />
    }

    if (!loaded) {
      return <LoadingProgress />
    }

    return (
      <div className="redeemcodes-view">
        {/* Header Section */}
        <div className="redeemcodes-header">
          <div className="redeemcodes-title-section">
            <h1 className="redeemcodes-title">
              <i className="fas fa-ticket-alt"></i>
              CÓDIGOS DE CANJE
            </h1>
          </div>
          <div className="redeemcodes-actions">
            <input
              type="text"
              className="filter-input"
              placeholder="Filtrar por Código"
              value={this.state.filterCode}
              onChange={(e) => this.setState({ filterCode: e.target.value })}
              style={{ width: "200px" }}
            />
            <button className="btn btn-vw btn-action" onClick={this.toggleForm}>
              <i
                className={`fas ${
                  showForm ? "fa-times" : "fa-plus-circle"
                } mr-2`}
              ></i>
              {showForm ? "Cancelar" : "Añadir Código de Canje"}
            </button>
          </div>
        </div>

        {showForm && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={this.toggleForm} />
            <div className="vw-modal__dialog">
              <div className="vw-modal__header">
                <h5 className="m-0">Crear Nuevo Código de Canje</h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.toggleForm}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body">
                <form onSubmit={this.handleSubmit}>
                  {role === "ADMIN" && (
                    <div className="form-group">
                      <label>Cliente</label>
                      <select
                        className="form-control"
                        name="customer"
                        value={newRedeemCode.customer}
                        onChange={this.handleInputChange}
                        required
                      >
                        <option value="">Seleccionar Cliente</option>
                        {customers &&
                          customers
                            .filter((customer) => customer.Type === "GENERAL" || customer.Type === "LICENCIA_BASICA" || customer.Type === "LICENCIA_PRO")
                            .sort((a, b) =>
                              a.Fullname.localeCompare(b.Fullname)
                            )
                            .map((customer) => (
                              <option value={customer._id} key={customer._id}>
                                {customer.Fullname}
                              </option>
                            ))}
                      </select>
                    </div>
                  )}
                  <div className="form-group">
                    <label>Código (opcional, se generará si está vacío)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      value={newRedeemCode.code}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Válido Desde</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="valid_from"
                      value={newRedeemCode.valid_from}
                      onChange={this.handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Válido Hasta</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="valid_to"
                      value={newRedeemCode.valid_to}
                      onChange={this.handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Productos</label>
                    <div className="d-flex mb-2">
                      <select
                        className="form-control mr-2"
                        name="currentProductId"
                        value={this.state.currentProductId}
                        onChange={this.handleProductChange}
                      >
                        <option value="">Seleccionar Producto</option>
                        {LOCKER_TYPES.map((locker) => (
                          <option value={locker.code} key={locker.code}>
                            {locker.name}
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        className="form-control mr-2"
                        name="currentProductQty"
                        value={this.state.currentProductQty}
                        onChange={this.handleProductChange}
                        min="1"
                        style={{ width: "80px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-vw"
                        onClick={this.addProduct}
                        disabled={newRedeemCode.products.length >= 1 || !this.state.currentProductId}
                      >
                        Añadir
                      </button>
                    </div>
                    {newRedeemCode.products.length >= 1 && (
                      <small className="text-warning">
                        <i className="fas fa-info-circle mr-1"></i>
                        Solo se permite 1 producto por código
                      </small>
                    )}
                    <ul className="list-group">
                      {newRedeemCode.products.map((product, index) => (
                        <li key={index} className="list-group-item">
                          {this.state.editingProductIndex === index ? (
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "10px" }}
                            >
                              <select
                                className="form-control"
                                defaultValue={product.product_id}
                                id={`edit-product-${index}`}
                                style={{ flex: 1 }}
                              >
                                {LOCKER_TYPES.map((locker) => (
                                  <option value={locker.code} key={locker.code}>
                                    {locker.name}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="number"
                                className="form-control"
                                defaultValue={product.product_qty}
                                min="1"
                                id={`edit-qty-${index}`}
                                style={{ width: "80px" }}
                              />
                              <button
                                type="button"
                                className="btn btn-sm btn-success"
                                onClick={() => {
                                  const productId = document.getElementById(
                                    `edit-product-${index}`
                                  ).value;
                                  const productQty = document.getElementById(
                                    `edit-qty-${index}`
                                  ).value;
                                  this.updateProduct(
                                    index,
                                    productId,
                                    productQty
                                  );
                                }}
                              >
                                Guardar
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                onClick={() =>
                                  this.setState({ editingProductIndex: null })
                                }
                              >
                                Cancelar
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-between align-items-center">
                              <span>
                                {product.product_name} - Cant:{" "}
                                {product.product_qty}
                              </span>
                              <div style={{ display: "flex", gap: "5px" }}>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary"
                                  onClick={() => this.editProduct(index)}
                                >
                                  Editar
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => this.removeProduct(index)}
                                >
                                  Eliminar
                                </button>
                              </div>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </form>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.toggleForm}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn bg-vw-dark text-white"
                  onClick={this.handleSubmit}
                  disabled={
                    !newRedeemCode.valid_from ||
                    !newRedeemCode.valid_to ||
                    newRedeemCode.products.length === 0 ||
                    (role === 'ADMIN' && !newRedeemCode.customer)
                  }
                >
                  Crear Código de Canje
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Main Content Card */}
        <div className="redeemcodes-card">
          <div className="card-header-custom">
            <i className="fas fa-list mr-2"></i>
            Lista de Códigos de Canje
          </div>
          <div className="card-body-custom">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>QR</th>
                    <th>Cliente</th>
                    <th>Productos</th>
                    <th>Válido Desde</th>
                    <th>Válido Hasta</th>
                    <th>Estado</th>
                    <th>Creado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRedeemCodes.map((redeemCode) => (
                    <tr key={redeemCode._id}>
                      <td>{redeemCode.code}</td>
                      <td>
                        <button
                          className="btn btn-sm bg-vw-dark text-white"
                          onClick={() => this.showQRCode(redeemCode)}
                          title="Mostrar Código QR"
                        >
                          <i className="fas fa-qrcode"></i>
                        </button>
                      </td>
                      <td>{this.getCustomerName(redeemCode.customer)}</td>
                      <td>
                        {redeemCode.products && redeemCode.products.length > 0
                          ? redeemCode.products
                              .map((p) => {
                                const productName =
                                  this.getTypeName(p.product_name) !== "NONE"
                                    ? this.getTypeName(p.product_name)
                                    : p.product_name;
                                return `${productName} (${p.product_qty})`;
                              })
                              .join(", ")
                          : "Ninguno"}
                      </td>
                      <td>
                        {new Date(redeemCode.valid_from).toLocaleString()}
                      </td>
                      <td>{new Date(redeemCode.valid_to).toLocaleString()}</td>
                      <td>
                        {redeemCode.redeemedAt &&
                        redeemCode.redeemedAt.length > 0 ? (
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => this.showRedeemedModal(redeemCode)}
                          >
                            <i className="fas fa-check-circle mr-1"></i>
                            Canjeado
                          </button>
                        ) : (
                          <span className="text-danger">
                            <i className="fas fa-times-circle mr-1"></i>
                            No canjeado
                          </span>
                        )}
                      </td>
                      <td>{new Date(redeemCode.createdAt).toLocaleString()}</td>
                      <td>
                        <div style={{ display: "flex", gap: "5px" }}>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => this.openEditModal(redeemCode)}
                            title="Editar"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => this.handleDeleteRedeemCode(redeemCode._id)}
                            title="Eliminar"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {showQRModal && selectedRedeemCode && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={this.closeQRModal} />
            <div className="vw-modal__dialog vw-modal__dialog--qr">
              <div className="vw-modal__header">
                <h5 className="m-0">Código QR - {selectedRedeemCode.code}</h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeQRModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body text-center">
                <QRCode
                  value={selectedRedeemCode.code}
                  size={256}
                  level={"H"}
                  includeMargin={true}
                />
                <div className="mt-3">
                  <p>
                    <strong>Código:</strong> {selectedRedeemCode.code}
                  </p>
                  <p>
                    <strong>Válido Desde:</strong>{" "}
                    {new Date(selectedRedeemCode.valid_from).toLocaleString()}
                  </p>
                  <p>
                    <strong>Válido Hasta:</strong>{" "}
                    {new Date(selectedRedeemCode.valid_to).toLocaleString()}
                  </p>
                </div>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.closeQRModal}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {showRedeemedModal && selectedRedeemedCode && (
          <div className="vw-modal">
            <div
              className="vw-modal__backdrop"
              onClick={this.closeRedeemedModal}
            />
            <div className="vw-modal__dialog vw-modal__dialog--redeemed">
              <div className="vw-modal__header">
                <h5 className="m-0">
                  Historial de Canjes - {selectedRedeemedCode.code}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeRedeemedModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body">
                <div className="list-group">
                  {selectedRedeemedCode.redeemedAt.map((redeem, index) => (
                    <div key={index} className="list-group-item">
                      <div
                        className="d-flex flex-wrap justify-content-between align-items-center"
                        style={{ gap: "10px" }}
                      >
                        <div style={{ minWidth: "250px" }}>
                          <strong>Fecha de canje:</strong>{" "}
                          {new Date(redeem.redeem_timestamp).toLocaleString()}
                        </div>
                        <div style={{ minWidth: "150px" }}>
                          <strong>Máquina:</strong> {redeem.redeem_machine}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.closeRedeemedModal}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {this.state.showEditModal && this.state.editRedeemCode && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={this.closeEditModal} />
            <div className="vw-modal__dialog">
              <div className="vw-modal__header">
                <h5 className="m-0">Editar Código de Canje</h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeEditModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body">
                <form>
                  <div className="form-group">
                    <label htmlFor="edit-code">Código</label>
                    <input
                      type="text"
                      className="form-control"
                      id="edit-code"
                      name="code"
                      value={this.state.editRedeemCode.code}
                      onChange={this.handleEditInputChange}
                      placeholder="Dejar vacío para generar automáticamente"
                    />
                  </div>

                  {role === "ADMIN" && (
                    <div className="form-group">
                      <label htmlFor="edit-customer">Cliente</label>
                      <select
                        className="form-control"
                        id="edit-customer"
                        name="customer"
                        value={this.state.editRedeemCode.customer}
                        onChange={this.handleEditInputChange}
                        required
                      >
                        <option value="">Seleccionar cliente</option>
                        {customers &&
                          customers
                            .filter((customer) => customer.Type === "GENERAL" || customer.Type === "LICENCIA_BASICA" || customer.Type === "LICENCIA_PRO")
                            .sort((a, b) =>
                              a.Fullname.localeCompare(b.Fullname)
                            )
                            .map((customer) => (
                              <option key={customer._id} value={customer._id}>
                                {customer.Fullname}
                              </option>
                            ))}
                      </select>
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="edit-valid_from">Válido Desde</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="edit-valid_from"
                      name="valid_from"
                      value={this.state.editRedeemCode.valid_from}
                      onChange={this.handleEditInputChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="edit-valid_to">Válido Hasta</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="edit-valid_to"
                      name="valid_to"
                      value={this.state.editRedeemCode.valid_to}
                      onChange={this.handleEditInputChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Productos</label>
                    <div
                      className="d-flex align-items-center mb-2"
                      style={{ gap: "10px" }}
                    >
                      <select
                        className="form-control"
                        name="editProductId"
                        value={this.state.editProductId}
                        onChange={this.handleEditProductChange}
                        style={{ flex: 1 }}
                      >
                        <option value="">Seleccionar tipo de taquilla</option>
                        {LOCKER_TYPES.map((locker) => (
                          <option value={locker.code} key={locker.code}>
                            {locker.name}
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        className="form-control"
                        name="editProductQty"
                        value={this.state.editProductQty}
                        onChange={this.handleEditProductChange}
                        placeholder="Cantidad"
                        min="1"
                        style={{ width: "80px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-vw"
                        onClick={this.addEditProduct}
                        disabled={this.state.editRedeemCode.products.length >= 1}
                      >
                        Añadir
                      </button>
                    </div>
                    {this.state.editRedeemCode.products.length >= 1 && (
                      <small className="text-warning">
                        <i className="fas fa-info-circle mr-1"></i>
                        Solo se permite 1 producto por código
                      </small>
                    )}
                    <ul className="list-group">
                      {this.state.editRedeemCode.products.map((product, index) => (
                        <li key={index} className="list-group-item">
                          {this.state.editingEditProductIndex === index ? (
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "10px" }}
                            >
                              <select
                                className="form-control"
                                defaultValue={product.product_id}
                                id={`edit-edit-product-${index}`}
                                style={{ flex: 1 }}
                              >
                                {LOCKER_TYPES.map((locker) => (
                                  <option value={locker.code} key={locker.code}>
                                    {locker.name}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="number"
                                className="form-control"
                                defaultValue={product.product_qty}
                                min="1"
                                id={`edit-edit-qty-${index}`}
                                style={{ width: "80px" }}
                              />
                              <button
                                type="button"
                                className="btn btn-sm btn-success"
                                onClick={() => {
                                  const productId = document.getElementById(
                                    `edit-edit-product-${index}`
                                  ).value;
                                  const productQty = document.getElementById(
                                    `edit-edit-qty-${index}`
                                  ).value;
                                  this.updateEditProduct(
                                    index,
                                    productId,
                                    productQty
                                  );
                                }}
                              >
                                Guardar
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                onClick={() =>
                                  this.setState({ editingEditProductIndex: null })
                                }
                              >
                                Cancelar
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-between align-items-center">
                              <span>
                                {product.product_name} - Cant:{" "}
                                {product.product_qty}
                              </span>
                              <div style={{ display: "flex", gap: "5px" }}>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary"
                                  onClick={() => this.editEditProduct(index)}
                                >
                                  Editar
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => this.removeEditProduct(index)}
                                >
                                  Eliminar
                                </button>
                              </div>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </form>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.closeEditModal}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn bg-vw-dark text-white"
                  onClick={this.handleEditSubmit}
                >
                  Actualizar Código de Canje
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.auth.role,
  type: state.auth.type,
  customerId: state.auth.id,
  customerFullname: state.auth.fullname,
  customer: state.customers.customer,
  redeemCodes: state.redeemCodes.redeemCodes,
  redeemCodesNeedRefresh: state.redeemCodes.redeemCodesNeedRefresh,
  loading: state.redeemCodes.loading,
  error: state.redeemCodes.error,
  machines: state.machines.machines,
  customers: state.customers.customers,
});

const mapDispatchToProps = (dispatch) => ({
  fetchRedeemCodes: bindActionCreators(fetchRedeemCodes, dispatch),
  addRedeemCode: bindActionCreators(addRedeemCode, dispatch),
  updateRedeemCode: bindActionCreators(updateRedeemCode, dispatch),
  deleteRedeemCode: bindActionCreators(deleteRedeemCode, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomersName: bindActionCreators(fetchCustomersName, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RedeemCodesView);
